import React from "react";
import { VerificationGetResponse } from "../../models";
import { Panel, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, Button, PanelHeader, PanelContent, Notice } from '@deque/cauldron-react'
import { CapitalizeFirstLetterOnly } from '../../utils/stringHelper'

import "./VerificationResult.scss";

type VerificationResultProps = {
  verification?: VerificationGetResponse,
  searchName: string,
  startOver: () => void,
};

export const VerificationResult = (props: VerificationResultProps) => {
  return (<>
    <h2 style={{ paddingLeft: '16px' }}>{props.searchName}</h2>
    {
      props.verification?.nfrs?.find((value) => value === "NA") ?
        <Notice type="info" title="Information">
          Student Information not available. Please contact Office of the Registrar.
        </Notice> :
        <>
          <Panel>
            <PanelHeader><h3>Student Registration Information</h3></PanelHeader>
            <PanelContent>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeader>Quarter</TableHeader>
                    <TableHeader>Workload</TableHeader>
                    <TableHeader>Standing</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.verification?.nfrs?.find((value) => value === "AT") ?
                    <TableRow key={"RegNonDisclosed"}>
                      <TableCell>NONDISCLOSED</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                   : 
                    props.verification?.registrationInformation.sort((a,b)=>a.quarter < b.quarter ? 1 : -1).map((item, index) => (
                    <TableRow key={item.quarterDisplay}>
                      <TableCell>{item.quarterDisplay}</TableCell>
                      <TableCell>{item.workload}</TableCell>
                      <TableCell>{item.standing}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </PanelContent>
          </Panel>
          <div style={{ paddingBottom: '16px' }} />
          <Panel>
            <PanelHeader><h3>Major Information</h3></PanelHeader>
            <PanelContent>
              <Table>
                <TableBody>
                  {props.verification?.nfrs?.find((value) => value === "MA") ? 
                  <TableRow key={"MajorNonDisclosed"}>
                      <TableCell>NONDISCLOSED</TableCell>
                    </TableRow>
                  : 
                  props.verification?.majorInformation.map((item, index) => (
                    <TableRow key={item}>
                      <TableCell>{item}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </PanelContent>
          </Panel>
          <div style={{ paddingBottom: '16px' }} />
          <Panel>
            <PanelHeader><h3>Degree Information</h3></PanelHeader>
            <PanelContent>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeader>Quarter Awarded</TableHeader>
                    <TableHeader>Date Awarded</TableHeader>
                    <TableHeader>Degree Awarded</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.verification?.nfrs?.find((value)=> value === "DG") ? 
                  <TableRow key={"DegreeNonDisclosed"}>
                      <TableCell>NONDISCLOSED</TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  : props.verification?.degreeInformation.map((item, index) => (
                    <TableRow key={item.degreeAwarded}>
                      <TableCell>{item.quarterAwarded}</TableCell>
                      <TableCell>{item.dateAwarded}</TableCell>
                      <TableCell>{item.degreeAwarded}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </PanelContent>
          </Panel>
        </>
    }
    <div style={{ paddingBottom: '16px' }} />
    <Button onClick={() => { props.startOver() }}>Search Again</Button>

  </>);
};
export default VerificationResult;